import React from "react";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { Spacer, VDBText } from "../..";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { css } from "styled-components/native";
import { DefaultTheme } from "styled-components/native";
import LineViewContainer from "@scenes/requests/utils/LineView";

type TextSearchProps = {
  value: string;
  type?: any;
  description?: string;
  isFocused: boolean;
  isShowAll?: boolean;
};

const TextSearchRecentItem = ({
  value,
  type,
  description,
  isFocused,
  isShowAll = false,
}: TextSearchProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();

  return (
    <HeaderContainer isFocused={isFocused}>
      <HeaderTextIcon>
        <TextContainer>
          <VDBText
            type={type ? type : typography["Body-R"]}
            color={
              isFocused
                ? theme["link-hover"]
                : isShowAll
                ? theme["link-static"]
                : theme["core-05"]
            }
            numberOfLines={0}
          >
            {value}
          </VDBText>
          {description && (
            <VDBText
              type={typography["Body-R"]}
              color={theme["core-05"]}
              numberOfLines={0}
            >
              {description}
            </VDBText>
          )}
        </TextContainer>
        <VDBIcon
          color={isFocused ? theme["core-06"] : theme["core-04"]}
          size={SpaceType.Big}
          variant={IconsVariant.VDBCustom}
          name={VDBIcons.ARROW_RIGHT}
        />
      </HeaderTextIcon>
      <Spacer size={SpaceType.Double} />
      <LineViewContainer background={isFocused ? "core-04" : "core-03"} />
    </HeaderContainer>
  );
};

const HeaderTextIcon = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const HeaderContainer = styled.View<{ isFocused: boolean }>`
  width: 100%;
  padding: ${SpaceType.Double}px;
  padding-bottom: 0px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-02"]};
`;

const TextContainer = styled.View`
  flex-direction: column;
  flex: 1;
  ${({ theme }: { theme: DefaultTheme }) =>
    theme.isLargeScreen &&
    css`
      max-width: 343px;
    `};
`;

export default TextSearchRecentItem;
